import { Link } from "react-router-dom";
import { BrandLogo } from "./BrandLogo";

export function PublicFooter() {
  return (
    <footer
      className="py-6 text-center text-sm"
      style={{
        color: "var(--l-text-muted)",
        borderTop: "1px solid var(--l-border)",
      }}
    >
      <div
        className="mx-auto flex flex-col items-center justify-between gap-3 sm:flex-row"
        style={{ maxWidth: 940, padding: "0 24px" }}
      >
        <div className="flex items-center gap-3">
          <BrandLogo to="/" variant="wordmark" className="transition-opacity hover:opacity-85" height={24} />
          <span>&copy; {new Date().getFullYear()}</span>
        </div>
        <div className="flex items-center gap-5">
          <Link to="/docs" style={{ color: "var(--l-text-muted)" }}>
            Docs
          </Link>
          <Link to="/blog" style={{ color: "var(--l-text-muted)" }}>
            Blog
          </Link>
          <Link to="/privacy" style={{ color: "var(--l-text-muted)" }}>
            Privacy
          </Link>
          <Link to="/terms" style={{ color: "var(--l-text-muted)" }}>
            Terms
          </Link>
        </div>
      </div>
    </footer>
  );
}
